import React from 'react'
import { Link as LinkIcon, LinkOff } from '@mui/icons-material'
import { Link, useMatch } from 'react-router-dom'
import { formatNumber, makeMaterialTypeToolTip } from 'utils/helpers'
import IconLabelButton from 'components/generic/buttons/IconLabelButton'
import getLinkCell from 'components/generic/datagrid/cells/LinkCell'

const getLinkingParams = rowData => {
  if (!rowData) return null
  return {
    purchaseOrderId: rowData.id,
    purchaseOrderNumber: rowData.readableId?.toString(),
    supplier: rowData.supplier,
  }
}

// This array should contain all possible fields a grid can have
export const purchaseOrderFields = [
  {
    field: 'purchaseOrderNumber',
    headerName: 'PO#',
    flex: 1,
    renderCell: params => {
      const { id, readableId } = params.row
      const match = useMatch({
        path: 'app/contracts/purchase-orders',
        end: true,
      })
      if (match) return getLinkCell(params, 'readableId')
      return (
        <Link to={`/app/contracts/purchase-orders/${id}`} target="_blank">
          {readableId}
        </Link>
      )
    },
  },
  {
    field: 'customerOrderNumber',
    headerName: 'Cust Order #',
    flex: 1,
  },
  {
    field: 'effectiveDate',
    headerName: 'Eff. Date',
    flex: 1,
  },
  {
    field: 'expirationDate',
    headerName: 'Exp. Date',
    flex: 1,
  },
  {
    field: 'customerName',
    headerName: 'Customer',
    flex: 1,
  },
  {
    field: 'inOrOutbound',
    headerName: 'Sale/Purchase',
    flex: 1,
  },
  {
    field: 'materials',
    headerName: 'Materials',
    flex: 1,
    sortable: false,
    renderCell: params => makeMaterialTypeToolTip(params.row.materials),
  },
  {
    field: 'price',
    headerName: 'Price',
    flex: 1,
    headerAlign: 'right',
    align: 'right',
    renderCell: params => formatNumber(`${params?.row?.price}`),
  },
  {
    field: 'ordered',
    headerName: 'Ordered',
    headerAlign: 'right',
    align: 'right',
    renderCell: params => params?.row?.ordered,
    flex: 1,
  },
  {
    field: 'remain',
    headerName: 'Remain',
    headerAlign: 'right',
    align: 'right',
    renderCell: params => params?.row?.remain,
    flex: 1,
  },
  {
    field: 'fulfilled',
    headerName: 'Fulfilled',
    headerAlign: 'right',
    align: 'right',
    renderCell: params => params?.row?.fulfilled,
    flex: 1,
  },
  {
    field: 'status',
    headerName: 'Status',
    flex: 1,
  },
  {
    field: 'isLinked',
    headerName: '',
    renderCell: params => {
      const isLinked = params?.row?.isLinked
      const linkedId = (isLinked?.linkedId || '').toString()
      const purchaseOrderNumber = params?.row?.readableId?.toString()
      return (
        <IconLabelButton
          variant="outlined"
          color={linkedId === purchaseOrderNumber ? 'error' : 'primary'}
          text={linkedId === purchaseOrderNumber ? 'Unlink' : 'Link'}
          data-testid={`${linkedId === purchaseOrderNumber ? 'unlink' : 'link'}-po-${purchaseOrderNumber}`}
          startIcon={linkedId === purchaseOrderNumber ? <LinkOff /> : <LinkIcon />}
          onClick={() => isLinked?.onLink(getLinkingParams(params?.row))}
        />
      )
    },
    flex: 1,
  },
]

export const purchaseOrderFieldsNonSortable = purchaseOrderFields.map(field => ({
  ...field,
  sortable: false,
}))
